module.exports = __webpack_public_path__ + "media/images/slide-5-f28233d5b5b7d67a68141434a34ed94a.jpg";